export const TASK_TIMEOUT = 5; // 5 seconds timeout
export const TASK_QUEUE_SIZE = 200;
export const MIN_REMAINING_TASKS = 10; // Minimum remaining tasks before fetching more

export const ANIMATION_INTERVAL_MS = 16; // ~60fps for smooth animation

export const MAX_EXP = 32; // Maximum experience points for leveling up
export const MAX_LEVEL = 25; // Maximum level
export const EXP_DROP_RATE_MIN = 0.2; // Rate at which experience drops every second
export const EXP_DROP_RATE_MAX = 4.0; // Rate at which experience drops every second
export const EXP_FREEZE_DURATION = 1.0; // Duration to freeze experience gain after a task is closed

